import React, { useEffect, useState } from "react";
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    BarChart,
    Bar,
} from "recharts";
import { api } from "../../../app/Api/ApiSlice";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "../../../components/Loader";

const StoreDashboard = () => {
    const { name } = useParams();

    const [isLoading, setIsLoading] = useState(true);
    const [metrics, setMetrics] = useState(null);

    useEffect(() => {
        const fetchMetrics = async () => {
            try {
                const res = await api.get(`/stores/${name}/manage/metrics`);
                setMetrics(res.data);
                setIsLoading(false);

            } catch (error) {
                console.log(error);
                setIsLoading(false);
                toast.error("Failed to load store metrics");
            }
        };

        fetchMetrics();
    }, [name]);

    if (isLoading) return <Loader />;
    if (!metrics) return <p>No data available</p>;

    // 🔹 Transform visits data
    const visitsData = metrics.visitsOverTime.map(v => ({
        label: `${v._id.month}/${v._id.year}`,
        visits: v.visits
    }));

    // 🔹 Transform revenue data
    const revenueData = metrics.revenueOverTime.map(r => ({
        label: `${r._id.month}/${r._id.year}`,
        revenue: r.revenue
    }));

    return (
        <div style={{ padding: "20px" }}>
            <h1>{name} Store Dashboard</h1>

            {/* ===== KPI CARDS ===== */}
            <div style={{ display: "flex", gap: "20px", marginBottom: "30px" }}>
                <div>
                    <h3>Total Visits</h3>
                    <p>{metrics.summary.totalVisits}</p>
                </div>

                <div>
                    <h3>Total Revenue</h3>
                    <p>{metrics.summary.revenue}</p>
                </div>

                <div>
                    <h3>Total Orders</h3>
                    <p>{metrics.summary.totalOrders}</p>
                </div>

                <div>
                    <h3>Avg Order Value</h3>
                    <p>{metrics.summary.avgOrderValue}</p>
                </div>
            </div>

            {/* ===== VISITS CHART ===== */}
            <div style={{ marginBottom: "40px" }}>
                <h2>Monthly Visits (MoM)</h2>
                <BarChart width={700} height={300} data={visitsData}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="label" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Bar dataKey="visits" name="Visits" />
                </BarChart>
            </div>

            {/* ===== REVENUE CHART ===== */}
            <div style={{ marginBottom: "40px" }}>
                <h2>Revenue Trend</h2>
                <LineChart width={700} height={300} data={revenueData}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="label" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Line type="monotone" dataKey="revenue" name="Revenue" />
                </LineChart>
            </div>
        </div>
    );
};

export default StoreDashboard;